import styled, { css } from 'styled-components'
import { belowTablet } from 'utilities/styled'
import { skeletonBackground } from 'components/skeleton/s'

export const Wrapper = styled.div`
    display: flex;
    flex-wrap: nowrap;
    gap: 48px;

    width: 100%;

    ${belowTablet`
        flex-wrap: wrap;
    `}
`

const container = css`
    flex-basis: 100%;
    align-self: start;

    border-radius: 8px;
    min-height: 200px;
    padding: 24px;
    box-shadow: inset 0 0 0 1px var(--huma-color-border-default);
`

export const SkeletonTable = styled.div`
    ${container}
`
export const SkeletonBar = styled.div`
    ${container}
`

export const SkeletonHeading = styled.div`
    ${skeletonBackground}

    margin-bottom: 8px;
    border-radius: 4px;
    width: 45%;
    height: 24px;
`

export const SkeletonPie = styled.div`
    position: relative;

    margin: 24px auto;
    border-radius: 50%;
    width: 160px;
    height: 160px;

    ${skeletonBackground}

    &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;

        border-radius: inherit;
        width: 112px;
        height: 112px;
        transform: translate(-50%, -50%);
        background-color: var(--huma-color-surface-default);
    }
`

export const SkeletonLegends = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    height: 24px;
`

export const SkeletonLegend = styled.div`
    position: relative;

    height: 16px;
    padding-inline-start: 14px;

    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;

        border-radius: 50%;
        width: 8px;
        height: 8px;
        transform: translateY(-50%);

        ${skeletonBackground}
    }

    span {
        display: block;

        border-radius: 4px;
        height: 16px;

        ${skeletonBackground}
    }

    &:nth-child(1) {
        width: 65px;
    }

    &:nth-child(2) {
        width: 80px;
    }

    &:nth-child(3) {
        width: 75px;
    }
`

export const SkeletonRow = styled.div`
    position: relative;

    padding-block: 18px;
    border-bottom: 1px solid var(--huma-color-border-default);

    span {
        display: block;

        border-radius: 4px;
        height: 20px;

        ${skeletonBackground}
    }

    &:nth-child(3n+1) span {
        width: 85%;
    }

    &:nth-child(3n+2) span {
        width: 65%;
    }

    &:nth-child(3n+3) span {
        width: 75%;
    }

    ${SkeletonBar} & {
        padding-block: 12px 24px;

        &::before {
            content: "";
            position: absolute;
            bottom: 8px;
            left: 0;
            right: 0;

            border-radius: 50vw;
            height: 8px;

            ${skeletonBackground}
        }
    }
`